import React from 'react';
import { Box, Stack, Typography, Checkbox } from "@mui/material";
import moment from "moment";
import MuiTable from "../../../../pages/admin/board/components/BoardTable/MuiTbale";
import AddCheckpointIcon from "../../../../styles/svg/group-plus-icon.svg";
import { CustomTextField } from '../../../TextField';

const MilestoneCheckpoints = ({
  checkpoint,
  handleCheckBox,
  handleCheckName,
  setCheckpoint,
  isEditable
}) => {
  return (
    <>
      <Stack direction="row" justifyContent="space-between" mx={2}>
        <Typography className="milestone-checkpoints-text">
          Checkpoints
        </Typography>
        {isEditable && (
          <img
            src={AddCheckpointIcon}
            alt="add checkpoint"
            width={20}
            onClick={() => setCheckpoint(true)}
          />
        )}
      </Stack>
      <Box m={1} className="edit-milestone-checkpoints-table">
        <MuiTable
          border={true}
          minRowHeight={40}
          initialRows={
            checkpoint
              ? checkpoint?.data?.data.responseData.map((ele, idx) => ({
                  id: idx,
                  ...ele,
                  checkpoint_name: {
                    checkpoint_name: ele.checkpoint_name,
                    id: ele.checkpoint_id,
                  },
                  is_done: {
                    is_done: ele.is_done,
                    id: ele.checkpoint_id,
                  },
                }))
              : []
          }
          columns={[
            {
              field: "checkpoint_name",
              headerName: "Check",
              minWidth: 135,
              flex: 1,
              sortable: false,
              resizable: false,
              renderCell: (value) => (
                <CustomTextField
                  variant="standard"
                  onKeyDown={(e) => {
                    e.stopPropagation();
                    handleCheckName(e, value.value.id);
                  }}
                  defaultValue={value.value.checkpoint_name}
                  inputProps={{ maxLength: 30 }}
                  className="checkpoint-name-input"
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      height: 32,
                      border: "none",
                      fontSize: "14px",
                    },
                  }}
                />
              ),
            },
            {
              field: "datetime",
              headerName: "Date",
              minWidth: 124,
              flex: 1,
              sortable: false,
              resizable: false,
              renderCell: (value) => (
                <span>{moment(value.value).format("MM/DD/YYYY")}</span>
              ),
            },
            {
              field: "is_done",
              headerName: "Actions",
              minWidth: 50,
              flex: 1,
              sortable: false,
              resizable: false,
              renderCell: (value) => (
                <Checkbox
                  className={`checkpoint-action-checkbox ${
                    !isEditable ? "disabled" : ""
                  }`}
                  disabled={!isEditable}
                  checked={value.value.is_done}
                  onChange={(e, val) =>
                    handleCheckBox(e, val, value.value.id)
                  }
                />
              ),
            },
          ]}
          footer={true}
        />
      </Box>
    </>
  );
};

export default MilestoneCheckpoints; 